import { useEffect, useState } from "react";

/**
 * Seconds left while `active` is true. Restarts at `seconds` each time
 * `active` turns true and stops at 0 (the caller decides what 0 means).
 */
export default function useCountdown(active, seconds = 10) {
  const [remaining, setRemaining] = useState(seconds);

  useEffect(() => {
    if (!active) return undefined;
    setRemaining(seconds);
    const startedAt = Date.now();
    const timer = setInterval(() => {
      const left = Math.max(0, seconds - Math.floor((Date.now() - startedAt) / 1000));
      setRemaining(left);
      if (left === 0) clearInterval(timer);
    }, 250);
    return () => clearInterval(timer);
  }, [active, seconds]);

  return remaining;
}
